import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import { DISCLAIMER_CONSULTATION_RESULTS_INGREDIENTS_CANCEL } from 'consts/copy';

import { SIMPLE_HERO_LAYOUT, type SimpleHeroProps } from '../SimpleHero';

export const SIMPLE_HERO_TRETINOIN_CONTENT: SimpleHeroProps = {
  header: (
    <React.Fragment>
      Tretinoin for clearer, <br />
      smoother skin
    </React.Fragment>
  ),
  body: 'Say so long to dull, broken out skin and hello to a bright, healthy glow. This potent prescription retinoid encourages skin cell turnover to help reveal fresh, smooth skin.',
  ctaButton: {
    buttonText: 'Get your custom formula',
    disclaimerText: DISCLAIMER_CONSULTATION_RESULTS_INGREDIENTS_CANCEL,
  },
  media: (
    <StaticImage
      src="../images/headerTretinoinDesktop@2x.jpg"
      alt="woman putting on custom formula"
      loading="eager"
    />
  ),
  layout: SIMPLE_HERO_LAYOUT.imageLast,
};
